import Vue from 'vue'
import VueI18n from 'vue-i18n'
import nlNL from '../assets/locales/nl-NL.json'
import enGB from '../assets/locales/en-GB.json'
import frFR from '../assets/locales/fr-FR.json'
import deDE from '../assets/locales/de-DE.json'

Vue.use(VueI18n)

let storedLanguage = localStorage.getItem('workflow-language')

// Check if localStorageItem is valid
if (!['en', 'nl', 'fr', 'de'].includes(storedLanguage)) {
  // Get browser language
  const browserLanguage = navigator.language.substring(0, 2)

  // Check if browser language is valid
  if (['en', 'nl', 'fr', 'de'].includes(browserLanguage)) {
    localStorage.setItem('workflow-language', 'nl')
    //localStorage.setItem('workflow-language', browserLanguage)
    storedLanguage = 'nl' //browserLanguage
  } else {
    localStorage.setItem('workflow-language', 'nl')
    storedLanguage = 'nl'
  }
}

const i18n = new VueI18n({
  locale: storedLanguage,
  messages: {
    'nl': nlNL,
    'en': enGB,
    'fr': frFR,
    'de': deDE
  },
  silentTranslationWarn: true
})

// this can be imported into a store, for translations in vuex
export default i18n
